// Interfaces for subscription details
export interface AvailableProduct {
  url?: string;
  productType: string;
  firstActiveDate?: string;
  isCompanyHubPublishedAndPremium?: boolean;
  activationDate?: string;
  isJsmPremium?: boolean;
  autoProvisionDate?: string;
  companyHubName?: string;
}

export interface Org {
  id: string;
  displayName: string;
}

export interface Site {
  avatar?: string;
  url: string;
  org?: Org;
  adminAccess: boolean;
  availableProducts: AvailableProduct[];
  displayName: string;
  cloudId: string;
}

export interface Link {
  linkType: string;
  url: string;
}

export interface User {
  email: string;
}

// New SubscriptionDetails interface for cloud site objects
export interface CloudSite {
  cloudSiteId: string;
  hostname: string;
  hostingPlatform: string;
  url: string;
  sen?: string;
  aliases?: string[];
  productType?: string;
}

export type SubscriptionDetails = CloudSite[];

// User Profile interface based on the actual data structure
export interface UserProfile {
  account_id: string;
  email: string;
  name: string;
  picture: string;
  account_status: string;
  characteristics: {
    not_mentionable: boolean;
  };
  last_updated: string;
  nickname: string;
  locale: string;
  extended_profile: {
    job_title: string;
    organization: string;
    department: string;
    phone_numbers: string[];
    team_type: string;
  };
  account_type: string;
  email_verified: boolean;
} 



export enum InstallationStatus {
  IDLE = 'idle',
  INSTALLING = 'installing',
  INSTALLED = 'installed',
  ERROR = 'error',
}

export interface InstallationDetails {
  enterpriseId: string;
  teamId: string;
  status: InstallationStatus;
  error?: string | undefined;
}

// Organization interface for workspace/org data
export interface Organization {
  id: string;
  name: string;
  sites: OrganizationSite[];
  accessEnabled: boolean | null;
  domains: string[] | null;
}

export interface OrganizationSite {
  id: string;
  siteUrl: string | null;
  orgId: string | null;
  siteAdmin: string | null;
  displayName: string | null;
  avatar: string | null;
  products: any[] | null;
}